import { createContext, useContext } from 'react';
import { ChildrenProps } from '@cotera/client/app/components/utils';
import {
  useDevModeStatus,
  DevModeStatus,
} from '@cotera/client/app/features/dev-mode';
import { CoteraApiV2, DevServerClient } from '../api/typed-client';

type State = CoteraApiV2;

const Context = createContext<State>(undefined as any);

export const ApiProvider: React.FC<
  ChildrenProps & {
    api: CoteraApiV2;
    localDevServer: DevServerClient;
  }
> = ({ children, api, localDevServer }) => {
  const devModeStatus = useDevModeStatus();
  const source = devModeStatus === DevModeStatus.On ? 'dev' : 'commited';

  return (
    <Context.Provider
      value={{
        ...api,
        t: {
          ...api.t,
          devServer:
            source === 'dev'
              ? (localDevServer as unknown as CoteraApiV2['t']['devServer'])
              : api.t.devServer,
        },
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const useApi = () => useContext(Context);
